import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail, Phone } from 'lucide-react';
import { Modal } from './ui/Modal';
import { Input } from './ui/Input';
import { Button } from './ui/Button';
export function Footer() {
  const navigate = useNavigate();
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const handleSecretClick = (e: React.MouseEvent) => {
    e.preventDefault();
    setIsAuthModalOpen(true);
    setError('');
    setPassword('');
  };
  const handleLogin = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === 'riezko') {
      setIsAuthModalOpen(false);
      navigate('/admin');
    } else {
      setError('Contraseña incorrecta');
      setPassword('');
    }
  };
  return <footer className="bg-gray-900 text-white pt-8 pb-6 sm:pt-12 md:pt-20 sm:pb-8 md:pb-10 rounded-t-2xl sm:rounded-t-[2rem] md:rounded-t-[3rem]" data-id="element-140">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8" data-id="element-141">
        <div className="grid grid-cols-1 gap-6 sm:gap-8 md:gap-12 md:grid-cols-2 lg:grid-cols-4 mb-6 sm:mb-10 md:mb-16" data-id="element-142">
          {/* Brand Column */}
          <div className="space-y-3 sm:space-y-4 md:space-y-6" data-id="element-143">
            <Link to="/" className="text-2xl sm:text-3xl font-black tracking-tighter text-white" data-id="element-144">
              FORAX<span className="text-blue-500" data-id="element-145">.</span>
            </Link>
            <p className="text-gray-400 leading-relaxed text-xs sm:text-sm md:text-base" data-id="element-146">
              Expertos en construcción corporativa. 40 años transformando
              visiones en realidad.
            </p>
            <div className="flex gap-3 sm:gap-4" data-id="element-147">
              <a href="#" className="h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-blue-600 hover:text-white transition-all" data-id="element-148">
                <Linkedin className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-149" />
              </a>
              <a href="#" className="h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-pink-600 hover:text-white transition-all" data-id="element-150">
                <Instagram className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-151" />
              </a>
              <a href="#" className="h-8 w-8 sm:h-10 sm:w-10 flex items-center justify-center rounded-full bg-gray-800 text-gray-400 hover:bg-blue-500 hover:text-white transition-all" data-id="element-152">
                <Facebook className="h-4 w-4 sm:h-5 sm:w-5" data-id="element-153" />
              </a>
            </div>
          </div>

          {/* Services Column - Hidden on mobile */}
          <div className="hidden md:block" data-id="element-154">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 lg:mb-6 text-white" data-id="element-155">
              Servicios
            </h3>
            <ul className="space-y-2 md:space-y-3 lg:space-y-4" data-id="element-156">
              <li data-id="element-157">
                <Link to="/proyectos" className="text-gray-400 hover:text-blue-400 transition-colors text-sm md:text-base" data-id="element-158">
                  Construcción Corporativa
                </Link>
              </li>
              <li data-id="element-159">
                <Link to="/proyectos" className="text-gray-400 hover:text-blue-400 transition-colors text-sm md:text-base" data-id="element-160">
                  Habilitación de oficinas
                </Link>
              </li>
              <li data-id="element-161">
                <Link to="/proyectos" className="text-gray-400 hover:text-blue-400 transition-colors text-sm md:text-base" data-id="element-162">
                  Retail y bancos
                </Link>
              </li>
            </ul>
          </div>

          {/* Company Column - Simplified on mobile */}
          <div data-id="element-163">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 lg:mb-6 text-white" data-id="element-164">
              Empresa
            </h3>
            <ul className="space-y-2 md:space-y-3 lg:space-y-4" data-id="element-165">
              <li data-id="element-166">
                <Link to="/quienes-somos" className="text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base" data-id="element-167">
                  Quiénes Somos
                </Link>
              </li>
              <li data-id="element-168">
                <Link to="/proyectos" className="text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base" data-id="element-169">
                  Proyectos
                </Link>
              </li>
              <li data-id="element-170">
                <Link to="/#contact" className="text-gray-400 hover:text-blue-400 transition-colors text-xs sm:text-sm md:text-base" data-id="element-171">
                  Contacto
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Column - Simplified on mobile */}
          <div data-id="element-172">
            <h3 className="text-base md:text-lg font-bold mb-3 md:mb-4 lg:mb-6 text-white" data-id="element-173">
              Contacto
            </h3>
            <ul className="space-y-2 md:space-y-3 lg:space-y-4" data-id="element-174">
              <li className="flex items-center gap-2 sm:gap-3 text-gray-400 text-xs sm:text-sm md:text-base" data-id="element-175">
                <Phone className="h-4 w-4 sm:h-5 sm:w-5 text-blue-500 shrink-0" data-id="element-176" />
                <span data-id="element-177">+56 2 2345 6789</span>
              </li>
              <li className="flex items-center gap-2 sm:gap-3 text-gray-400 text-xs sm:text-sm md:text-base" data-id="element-178">
                <Mail className="h-4 w-4 sm:h-5 sm:w-5 text-blue-500 shrink-0" data-id="element-179" />
                <span data-id="element-180">contacto@forax.cl</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-4 sm:pt-6 md:pt-8 flex flex-col md:flex-row justify-between items-center gap-3 sm:gap-4" data-id="element-181">
          <button onClick={handleSecretClick} className="text-gray-500 text-xs sm:text-sm text-center md:text-left hover:text-gray-400 transition-colors cursor-default" aria-label="Admin access" data-id="element-182">
            © {new Date().getFullYear()} FORAX Construcción
          </button>
          <div className="flex gap-4 sm:gap-6 text-xs sm:text-sm text-gray-500" data-id="element-183">
            <a href="#" className="hover:text-white transition-colors" data-id="element-184">
              Privacidad
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-185">
              Términos
            </a>
          </div>
        </div>
      </div>

      <Modal isOpen={isAuthModalOpen} onClose={() => setIsAuthModalOpen(false)} title="Acceso Administrativo" data-id="element-186">
        <form onSubmit={handleLogin} className="space-y-4" data-id="element-187">
          <Input label="Contraseña" type="password" value={password} onChange={e => setPassword(e.target.value)} error={error} placeholder="Ingrese contraseña de acceso" autoFocus data-id="element-188" />
          <div className="flex justify-end gap-3 pt-2" data-id="element-189">
            <Button type="button" variant="secondary" onClick={() => setIsAuthModalOpen(false)} data-id="element-190">
              Cancelar
            </Button>
            <Button type="submit" data-id="element-191">Ingresar</Button>
          </div>
        </form>
      </Modal>
    </footer>;
}